import { createStyles, Theme, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => {
    const mainThemeColor = theme.palette.primary.main;
    return createStyles({
        label: {
            color: theme.palette.getContrastText(mainThemeColor),
        },
    });
};

export type TThemableProps = WithStyles<typeof styles>;

export const Themable = withStyles(styles, { withTheme: true });
